@use "Styles/components/buttons";

:host {
    display: inline-block;
}

:host([hidden]) {
    display: none !important;
}

:host([full-width]) {
    display: block;
    width: 100%;

    .vm-button {
        width: 100%;
    }
}
